
const TYP_ENTITY = 1;
const TYP_DAYCOMM = 2;
const TYP_PHONESYS = 3;
const TYP_REWORK = 4;
const TYP_SUPPLIER = 5;
const TYP_BUDGET = 6;

export default {
    TYP_ENTITY,
    TYP_DAYCOMM,
    TYP_PHONESYS,
    TYP_REWORK,
    TYP_SUPPLIER,
    TYP_BUDGET,
    types: [
        { 
            id: TYP_ENTITY, label: 'Standard'
        },
        {
            id: TYP_DAYCOMM, label: 'Day'
        },
        {
            id: TYP_PHONESYS, label: 'Phone'
        },
        {
            id: TYP_REWORK, label: 'Rework'
        },
        {
            id: TYP_SUPPLIER, label: 'Supplier'
        },
        {
            id: TYP_BUDGET, label: 'Budget'
        }
    ],
    filters: [
        TYP_ENTITY, TYP_PHONESYS
    ],
    defaultFilters: [
        TYP_ENTITY
    ]
}